import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from 'utils/authentication';

const PrivateNoSpaceRoute = () => {
  if (isAuthenticated()) {
    return <Outlet />;
  }
  return <Navigate to="/users/login" />;
};

export default PrivateNoSpaceRoute;
